import Phaser from 'phaser'
import BootScene from './scenes/BootScene'
import PlayScene from './scenes/PlayScene'
import EndScene from './scenes/EndScene'

let game = null

/* eslint-disable no-new */
function launch () {
  game = new Phaser.Game({
    type: Phaser.AUTO,
    width: 767,
    height: 583,
    parent: 'jumpGame-container',
    title: 'Frog Jump',
    transparent: true,
    scene: [BootScene, PlayScene, EndScene]
  })
}

function resetGame () {
  game.scene.scenes[1].restartLevel()
}

function destroyGame () {
  game.scene.scenes[1].destroyGame()
}

export default launch 
export { launch, resetGame, destroyGame }
